<template>
  <v-card flat outlined>
    <v-card-title>Choose your Addons</v-card-title>
    <v-card-text>
      <loading v-if="loading"></loading>
      <template v-else>
        <v-row>
            <v-col
              cols="12"
              :class="option.class ? option.class : 'py-5'"
              v-for="(option) in options"
              v-bind:key="option.key"
            >
              <Subfield :option="option" />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            sm="8"
            md="6"
            v-for="addon in addons"
            v-bind:key="addon.ID"
          >
            <h3>
              <v-checkbox
                @change="toggleAddon(addon.ID)"
                :input-value="addonSelected(addon.ID)"
                :value="addon.ID"
                hide-details
              >
                <div slot="label" v-html="addon.TitleHTML"/>
              </v-checkbox>
            </h3>
          </v-col>
        </v-row>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import Vue from "vue";
import Loading from "../../shared/Loading";
import Subfield from "../Subfield";

import {
  GET_EVENTS,
  GET_ADDONS,
  GET_SELECTED_ADDONS,
  POST_SELECTED_ADDONS,
} from "../../../store/actions.type";

export default {
  name: "AddonsModal",
  components: {
    Loading,
    Subfield,
  },
  data() {
    return {
      loading: true,
      selectedAddons: [],
    };
  },
  computed: {
    options() {
      return this.$store.getters.getCurrentOptionsBySection('addonsmodal');
    },
    addons() {
      return this.$store.getters.getAddons;
    },
  },
  methods: {
    addonSelected(addon_id) {
      if (!this.selectedAddons.length) {
        return null;
      }
      return this.selectedAddons.indexOf(addon_id) >= 0
        ? addon_id
        : null;
    },
    toggleAddon(addon_id) {
      var index = this.selectedAddons.indexOf(addon_id);
      if (index === -1) {
        this.selectedAddons.push(addon_id);
      } else {
        this.selectedAddons.splice(index, 1);
      }
      this.finish();
    },
    finish() {
      this.$gtag.event("api", {
        event_category: "addons",
        event_label: "set_selected_addons",
      });
      this.$store
        .dispatch(POST_SELECTED_ADDONS, this.selectedAddons)
        .then(() => {
          this.loading = false;
          this.$store.dispatch(GET_EVENTS);
          this.$emit("done");
        });
    },
  },
  mounted() {
    let self = this;
    this.$nextTick(function () {
      this.$gtag.event("api", {
        event_category: "addons",
        event_label: "get_addons",
      });
      this.$store.dispatch(GET_ADDONS).then(() => {
        this.$gtag.event("api", {
          event_category: "addons",
          event_label: "get_addons",
        });
        this.$store.dispatch(GET_SELECTED_ADDONS).then(() => {
          this.$forceUpdate();
          Object.keys(this.$store.getters.getSelectedAddons).forEach(key => {
             Vue.set(this.selectedAddons, key, this.$store.getters.getSelectedAddons[key]);
           });
           this.selectedAddons = this.$store.getters.getSelectedAddons;
          Vue.nextTick().then(function () {
            self.loading = false;
          });
        });
      });
    });
  },
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0px !important;
}
.v-card {
  border-color: #0057B8;
}
</style>